export default "__VITE_ASSET__CPfOnoA3__"